// Realaus KELIO atstumas (ne tiesi linija) tarp dviejų taškų.
// Naudojam OSRM viešą serverį (nemokamas, be rakto). Fallback — haversine.
//
// LAIKINA: viešas OSRM serveris be garantijų. Vėliau — savo/ORS su raktu.
// Idėja: km fiksuojam KAI atidaroma vieta (dažniausiai geras signalas namie),
// įrašom lokaliai, o „Buvau čia" metu tiesiog įskaitom (veikia ir be interneto).

import { haversine } from './atstumas'

const RAKTAS = 'numatyti_km' // { [vietaId]: km }

function getVisus() {
  try {
    const r = localStorage.getItem(RAKTAS)
    return r ? JSON.parse(r) : {}
  } catch {
    return {}
  }
}

function issaugoti(map) {
  try { localStorage.setItem(RAKTAS, JSON.stringify(map)) } catch {}
}

// Grąžina anksčiau užfiksuotą km tai vietai (arba null).
export function getNumatytaKm(vietaId) {
  const v = getVisus()[vietaId]
  return typeof v === 'number' ? v : null
}

// Realaus kelio km per OSRM. a,b = { lat, lng }. Grąžina skaičių arba null.
export async function keliokm(a, b) {
  if (!a || !b) return null
  try {
    const url = `https://router.project-osrm.org/route/v1/driving/` +
      `${a.lng},${a.lat};${b.lng},${b.lat}?overview=false&alternatives=false&steps=false`
    const ctrl = new AbortController()
    const timeout = setTimeout(() => ctrl.abort(), 8000)
    const r = await fetch(url, { signal: ctrl.signal })
    clearTimeout(timeout)
    const j = await r.json()
    if (j && j.code === 'Ok' && j.routes && j.routes[0]) {
      return j.routes[0].distance / 1000
    }
  } catch {
    // tinklo klaida / timeout — kris į fallback
  }
  return null
}

// Užfiksuoja kelio km vietai (kai ji atidaroma). startas,vieta = { lat, lng }.
// Grąžina km (route arba haversine fallback). Įrašo tik jei dar nebuvo.
export async function fiksuotiKelia(vietaId, startas, vieta) {
  if (!startas || !vieta) return null
  const jauYra = getNumatytaKm(vietaId)
  if (jauYra != null) return jauYra
  let km = await keliokm(startas, vieta)
  if (km == null) km = haversine(startas.lat, startas.lng, vieta.lat, vieta.lng)
  const map = getVisus()
  map[vietaId] = Math.round(km)
  issaugoti(map)
  return map[vietaId]
}

// „Buvau čia" metu: paimam užfiksuotą km, jei nėra — bandom dabar, tada haversine.
export async function gautiKeliaBuvauCia(vietaId, startas, vieta) {
  const numatyta = getNumatytaKm(vietaId)
  if (numatyta != null) return numatyta
  if (startas && vieta) {
    let km = await keliokm(startas, vieta)
    if (km == null) km = haversine(startas.lat, startas.lng, vieta.lat, vieta.lng)
    return Math.round(km)
  }
  return null
}
